<select class="form-control" [(ngModel)]="selectedIndex" [ngClass]="{'border-danger':selectedIndex === null}" (change)="setAddress()">
  @if (addresses.length > 1) {
    <option></option>
  }
  @for (address of addresses; track address; let i = $index) {
    <option [value]="i">
      {{ address.street }} {{address.house_number}} {{address.house_number_addition?address.house_number_addition + ' ' :''}}{{ address.zip }} {{ address.city }}
    </option>
  }
</select>
